/**
 * There will be one reducer file per page / common component
 */
import {
    GET_SHARE_TEMPLATE,
    GET_SHARE_TEMPLATE_SUCCESS,
    GET_SHARE_TEMPLATE_FAILURE
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    userList: []
};

const ShareTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SHARE_TEMPLATE:
            return {
                ...state,
                loading: true,
                
            };
        case GET_SHARE_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                statusCode: action.payload.statusCode,
                statusMessage: action.payload.statusMessage,
            };
        case GET_SHARE_TEMPLATE_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default ShareTemplateReducer;
